import React from 'react';
import { styled } from '@linaria/react';
import PropTypes from 'prop-types';

import { Star } from '../icon';

const Rating = styled.div`
  display: flex;
  align-items: center;
  font-weight: var(--bb-bestWriters-writer-rating-font-weight);
  font-size: var(--bb-fz-caption, 14px);
  color: var(--bb-color-basic-5, #424242);
  line-height: var(--bb-lh-caption, 21px);
  margin-bottom: 8px;
`;

const RatingBar = styled.div`
  position: relative;
  height: 2px;
  width: 140px;
  background: var(--bb-color-basic-3, #c1c1c1);
`;

const RatingIndicator = styled.div`
  position: relative;
  height: 2px;
  background: var(--bb-color-primary-0, #0080d1);
  width: ${props => props.rating * 14}px;
`;

const StarWrapper = styled.div`
  display: flex;
  margin-right: 4px;
  & svg {
    width: var(--bb-rating-star-width);
    height: var(--bb-rating-star-height);
  }
  & path {
    fill: var(--bb-rating-star-fill);
    stroke: var(--bb-rating-star-stroke);
  }
`;

const RatingMax = styled.span`
  font-size: var(--bb-fz-caption, 14px);
  line-height: var(--bb-lh-caption, 21px);
  color: var(--bb-color-basic-5, #424242);
  font-weight: var(--bb-bestWriters-max-rating-font-weight);
`;

const WriterRating = ({ rating, showRatingBar = false }) => (
  <>
    <Rating>
      <StarWrapper>
        <Star />
      </StarWrapper>
      {rating}
      <RatingMax>/10</RatingMax>
    </Rating>

    {showRatingBar && (
      <RatingBar>
        <RatingIndicator rating={rating} />
      </RatingBar>
    )}
  </>
);

WriterRating.propTypes = {
  rating: PropTypes.number.isRequired,
  showRatingBar: PropTypes.bool,
};

export default WriterRating;
